import DefaultElementNodeType from '../DefaultElementNodeType';
import {TECHNOLOGY_DEVICE} from '../../metamodel/Concept';

export default class DeviceNodeType extends DefaultElementNodeType {
	static get typeName() {
		return TECHNOLOGY_DEVICE;
	}
}
